import React, { useState } from 'react'
import Collapsible from 'react-collapsible'
import { FaBookOpen } from 'react-icons/fa';
import styles from '../Components/Educations.module.css'
import EducationEachWrapper from './EducationEachWrapper';

const Educations = props => {
    const { data } = props
    const [isOpen, setIsOpen] = useState(false);


    return (
        <div className={styles.mainWrapper}>
            <Collapsible trigger={
                <div className={isOpen === true ? styles.mainHeaderOpen : styles.mainHeader}>
                    <div className={styles.leftCol}>
                        <FaBookOpen />
                        <span className={styles.headerTitle}>
                            Education
                        </span>
                    </div>
                    <div className={styles.rightCol}>

                    </div>
                </div>
            }
                isOpen={false}
                onOpening={() => setIsOpen(true)}
                onClose={() => setIsOpen(false)}
            >

                <div className={styles.mainContainer}>
                    {data?.map((item, index) => (
                        <EducationEachWrapper
                            item={item}
                            key={index}
                        />
                    ))}
                </div>
            </Collapsible>
        </div>
    )
}

export default Educations